import React from 'react';
import CategoryBase from '../Component/CategoryBase';

const CategoryZootechnicalCase = () => {
  return <CategoryBase baseEndpoint="category_zootechnical_case" />;
};

export default CategoryZootechnicalCase;
